/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Forbidden,
  NotFound,
  SiteHealthResponse,
  SiteHealthSummaryResponse,
  SitesHealthRequestBody,
  Unauthorized,
} from '../models';

export interface CrmCustomersHealthGetCustomerSiteHealthRequest {
    customerId: string;
}

export interface CrmCustomersHealthGetSitesHealthRequest {
    sitesHealthRequestBody: SitesHealthRequestBody;
}

/**
 * 
 */
export class CRMCustomersHealthApi extends runtime.BaseAPI {

    /**
     * Retrieves detailed installation health status for a specific customer. Returns comprehensive health metrics including device connectivity, data quality, last communication timestamps, error counts, and diagnostic information for troubleshooting
     * Get Customer Site Health Details
     */
    async crmCustomersHealthGetCustomerSiteHealthRaw(requestParameters: CrmCustomersHealthGetCustomerSiteHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteHealthResponse>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling crmCustomersHealthGetCustomerSiteHealth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{customerId}/health/site`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves detailed installation health status for a specific customer. Returns comprehensive health metrics including device connectivity, data quality, last communication timestamps, error counts, and diagnostic information for troubleshooting
     * Get Customer Site Health Details
     */
    async crmCustomersHealthGetCustomerSiteHealth(requestParameters: CrmCustomersHealthGetCustomerSiteHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteHealthResponse> {
        const response = await this.crmCustomersHealthGetCustomerSiteHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves installation health status for a batch of customers by their IDs. Returns health summaries including device connectivity, data freshness, communication errors, and overall site status. Useful for dashboard overviews and bulk monitoring
     * Get Installation Health for Multiple Customers
     */
    async crmCustomersHealthGetSitesHealthRaw(requestParameters: CrmCustomersHealthGetSitesHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SiteHealthSummaryResponse>>> {
        if (requestParameters.sitesHealthRequestBody === null || requestParameters.sitesHealthRequestBody === undefined) {
            throw new runtime.RequiredError('sitesHealthRequestBody','Required parameter requestParameters.sitesHealthRequestBody was null or undefined when calling crmCustomersHealthGetSitesHealth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/health/sites`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sitesHealthRequestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves installation health status for a batch of customers by their IDs. Returns health summaries including device connectivity, data freshness, communication errors, and overall site status. Useful for dashboard overviews and bulk monitoring
     * Get Installation Health for Multiple Customers
     */
    async crmCustomersHealthGetSitesHealth(requestParameters: CrmCustomersHealthGetSitesHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SiteHealthSummaryResponse>> {
        const response = await this.crmCustomersHealthGetSitesHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
